import React, { ReactNode, createContext, useContext } from "react";

interface LocaleContextType {
  locale: string;
  setLocale: (locale: string) => void;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

interface LocaleProviderProps {
  children: ReactNode;
  location: any;
}

class LocaleProvider extends React.Component<LocaleProviderProps, { locale: string, setLocale: (locale: string) => void }> {
  state = {
    locale: "en",
    setLocale: () => {}
  }

  setLocale = (locale: string) => {
    this.setState({ locale });
  }

  componentDidMount(): void {
    const { location } = this.props;

    if(location.pathname.includes("/fr/")) {
      this.setState({ locale: "fr" });
    } else if(location.pathname.includes("/de/")) {
      this.setState({ locale: "de" });
    } else {
      this.setState({ locale: "en" });
    }
  }
  
  render() {
    const { children } = this.props;
    const { locale } = this.state;

    return(
      <LocaleContext.Provider value={{
        locale,
        setLocale: this.setLocale
      }}>
        {children}
      </LocaleContext.Provider>
    )
  }
}

// Hook to use locale context
export const useLocale = (): LocaleContextType => {
  const context = useContext(LocaleContext);
  if (context === undefined) {
    throw new Error("useLocale must be used within a LocaleProvider");
  }
  return context;
};

export default LocaleContext;
export { LocaleProvider };
